import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

function IconButton({
  iconName = '',
  className = '',
  onClick = () => {},
  label = '',
  ...rest
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`tv-icon_button ${className}`}
      tabIndex={0}
      {...rest}
    >
      <i className={`fa fa-${iconName}`} aria-label={label} />
    </button>
  );
}

IconButton.propTypes = {
  iconName: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string,
};

export default IconButton;
